<template>
  <div class="system-page-item">
    <NuxtLink :to="link" class="system-page-item__inner">
      <div class="system-page-item__image-holder">
        <transition name="fade">
          <ObjectFitImage
            v-if="activeImage"
            className="system-page-item__image"
            :key="activeImageKey"
            :title="setProperFieldExternalFirst(activeImage, 'title') || 'image'"
            :url="baseUrlMedia + activeImage.fileId + '/' + activeImage.fileName + largeImgRatio"
          />
        </transition>
      </div>
      <div class="system-page-item__content" :class="{ 'system-page-item__content_no-indent': !(resources && resources.length > 1) }">
        <div class="system-page-item__slider" v-if="resources && resources.length > 1" @click.prevent>
          <div
            class="system-page-item__slider-item"
            v-for="(image, index) in truncatedResources"
            :key="image.fileId || index"
            @click="setActiveImage(index)"
          >
            <ObjectFitImage
              :className="index === imgNum ? sliderImageActiveClass : sliderImageClass"
              :title="setProperFieldExternalFirst(image, 'title') || 'image'"
              :url="baseUrlMedia + image.fileId + '/' + image.fileName + smallImgRatio"
            />
          </div>
        </div>
        <b class="system-page-item__title">{{ title }}</b>
        <span class="system-page-item__description">{{ longDescr }}</span>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';
  import { storeToRefs } from 'pinia';
  import { setProperFieldExternalFirst } from '@/utils/fieldGetters';

  // ObjectFitImage component is auto-imported by Nuxt

  interface ResourceItem {
    fileId: string;
    fileName: string;
    external?: {
      title?: string;
      [key: string]: any;
    };
    title?: string;
    [key: string]: any;
  }

  const props = defineProps<{
    title?: string;
    longDescr?: string;
    resources?: ResourceItem[];
    link?: string;
  }>();

  const mainStore = useMainStore();
  const { baseUrlMedia } = storeToRefs(mainStore);

  const imgNum = ref(0);
  const largeImgRatio = '?width=540&height=375';
  const smallImgRatio = '?width=90&height=90';
  const localResources = ref<ResourceItem[]>(props.resources || []);

  watch(
    () => props.resources,
    (val) => {
      localResources.value = val || [];
    }
  );

  const truncatedResources = computed(() => (localResources.value ? localResources.value.slice(0, 3) : []));

  const activeImage = computed(() => truncatedResources.value[imgNum.value] || null);
  const activeImageKey = computed(() =>
    activeImage.value ? activeImage.value.fileId || activeImage.value.fileName || imgNum.value : 'none'
  );
  const sliderImageClass = 'system-page-item__slider-image';
  const sliderImageActiveClass = 'system-page-item__slider-image system-page-item__slider-image_active';

  function setActiveImage(index: number): void {
    imgNum.value = index;
  }
</script>
